export const SESSION_TIMEOUT = 60 * 60; // seconds before idle
export const TIMEOUT_PROMPT = 180; // seconds remaining when prompt appears
